// extracted by mini-css-extract-plugin
export default {"new-team-form":"style_new-team-form__v4cjp","new-team-form-error":"style_new-team-form-error__EXrpV"};